(() => {
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => [...r.querySelectorAll(s)];
  const root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  const T = window.SOLO || {};
  const reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;
  const lang = document.documentElement.lang || 'fr';

  /* ---------- annonces ---------- */
  // Hors d’une fenêtre modale ouverte, le reste de la page est inerte : on annonce et on affiche dans la fenêtre.
  let tt, st;
  const host = () => $('dialog[open]') || document.body;
  function say(msg) {
    const d = $('dialog[open]');
    const live = (d && $('[data-live]', d)) || $('#sr-live');
    if (!live || !msg) return;
    live.textContent = '';
    clearTimeout(st); st = setTimeout(() => { live.textContent = msg; }, 120);
  }
  function toast(msg) {
    let t = $('.toast');
    if (!t) { t = document.createElement('div'); t.className = 'toast'; t.setAttribute('aria-hidden', 'true'); }
    if (t.parentNode !== host()) host().append(t);
    t.textContent = msg; t.classList.add('show');
    say(msg);
    clearTimeout(tt); tt = setTimeout(() => t.classList.remove('show'), 4500);
  }
  const plain = (html) => { const e = document.createElement('div'); e.innerHTML = html || ''; return e.textContent.trim(); };

  // Lien vers une ancre de la page : toutes les sections sont rendues avant le défilement (voir content-visibility dans base.css).
  document.addEventListener('click', (e) => {
    const a = e.target.closest && e.target.closest('a[href*="#"]');
    if (a && a.hash && a.pathname === location.pathname) document.documentElement.classList.add('cv-off');
  }, true);

  /* ---------- fenêtres (dialog) ---------- */
  function openDialog(d) {
    if (!d || d.open) return;
    d.showModal();
    requestAnimationFrame(() => d.classList.add('is-open'));
  }
  function closeDialog(d) {
    if (!d || !d.open) return;
    d.classList.remove('is-open');
    let done = false;
    const end = () => { if (done) return; done = true; d.close(); };
    d.addEventListener('transitionend', end, { once: true });
    setTimeout(end, reduce ? 0 : 400);
  }
  document.addEventListener('cancel', (e) => {
    const d = e.target;
    if (d.matches && d.matches('dialog.drw, dialog.pop')) { e.preventDefault(); closeDialog(d); }
  }, true);
  document.addEventListener('click', (e) => {
    const d = e.target;
    if (!(d instanceof HTMLDialogElement) || !d.open) return;
    const r = d.getBoundingClientRect();
    if (e.clientX < r.left || e.clientX > r.right || e.clientY < r.top || e.clientY > r.bottom) closeDialog(d);
  });

  /* ---------- panier ---------- */
  const drw = () => $('#cart');
  function setCount(n) {
    $$('[data-count]').forEach((e) => { e.textContent = n; e.toggleAttribute('data-empty', +n === 0); });
    $$('.hd__cart .sr').forEach((e) => { e.textContent = ', ' + (+n === 1 ? T.cart_one : T.cart_other).replace('[n]', n); });
  }
  function swap(sections) {
    const html = sections && sections['cart-drawer'];
    if (!html) return;
    const doc = new DOMParser().parseFromString(html, 'text/html');
    const n = $('[data-cart-count]', doc);
    if (n) setCount(n.dataset.cartCount);
    const fresh = $('.drw__content', doc), cur = $('.drw__content');
    if (fresh && cur) {
      const a = document.activeElement, ds = a && a.dataset ? a.dataset : {};
      const sel = ds.key && window.CSS && CSS.escape ? `.drw [data-key="${CSS.escape(ds.key)}"][data-act="${ds.act}"]` : null;
      const wasInside = a && cur.contains(a);
      cur.replaceWith(fresh);
      if (drw() && drw().open && wasInside) {
        const target = (sel && $(sel)) || $('.drw .li__rm') || $('.drw .x');
        target && target.focus({ preventScroll: true });
      }
    }
    const b = $('.hd__cart'); if (b) { b.classList.remove('bump'); void b.offsetWidth; b.classList.add('bump'); }
  }
  let busy = false;
  async function post(path, body, withSections = true) {
    const form = body instanceof FormData;
    if (withSections) {
      if (form) { body.append('sections', 'cart-drawer'); body.append('sections_url', location.pathname); }
      else body = { ...body, sections: 'cart-drawer', sections_url: location.pathname };
    }
    const r = await fetch(root + path, {
      method: 'POST',
      headers: form ? { Accept: 'application/json' } : { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: form ? body : JSON.stringify(body),
    });
    const j = await r.json().catch(() => ({}));
    if (!r.ok) { toast(j.description || j.message || T.error); return null; }
    return j;
  }
  async function api(path, body, before) {
    if (busy) return null;
    busy = true;
    const d = drw(); d && d.classList.add('busy');
    try {
      if (before && !(await post(before.path, before.body, false))) return null;
      const j = await post(path, body);
      if (j) swap(j.sections);
      return j;
    } catch (e) { toast(T.error); return null; } finally { busy = false; d && d.classList.remove('busy'); }
  }
  async function refreshCart() {
    try {
      const r = await fetch(`${root}?sections=cart-drawer`, { headers: { Accept: 'application/json' } });
      if (r.ok) swap(await r.json());
    } catch (e) {}
  }
  window.addEventListener('pageshow', (e) => { if (e.persisted) refreshCart(); });

  document.addEventListener('submit', async (e) => {
    const f = e.target.closest('form[data-ajax-add]');
    if (!f || !drw()) return;
    e.preventDefault();
    const fd = new FormData(f);
    const btn = e.submitter && e.submitter.classList.contains('btn') ? e.submitter : $('[type=submit]', f);
    if (fd.has('quantity')) fd.set('quantity', Math.max(1, Math.min(99, parseInt(fd.get('quantity'), 10) || 1)));
    if (btn) btn.setAttribute('aria-disabled', 'true');
    const ok = await api('cart/add.js', fd);
    if (btn) btn.removeAttribute('aria-disabled');
    if (!ok) return;
    openDialog(drw());
    if (btn) {
      const o = btn.innerHTML; btn.classList.add('is-ok'); btn.textContent = T.added;
      setTimeout(() => { btn.classList.remove('is-ok'); btn.innerHTML = o; }, 1600);
    }
  });

  document.addEventListener('click', (e) => {
    const t = e.target.closest('[data-open-cart],[data-close],[data-key][data-act],[data-lot-add],[data-step],[data-zoom],[data-lb-close],[data-lb-step],[data-pop-close],[data-pop-open],[data-pop-hide],[data-copy],.mnav__panel a');
    if (!t) return;
    if ('openCart' in t.dataset) { if (drw()) { e.preventDefault(); openDialog(drw()); } }
    else if ('close' in t.dataset) { e.preventDefault(); closeDialog(t.closest('dialog')); }
    else if (t.dataset.key) {
      const q = Math.max(0, +t.dataset.qty || 0), li = t.closest('.li'), name = li && $('[data-name]', li);
      api('cart/change.js', { id: t.dataset.key, quantity: q }).then((j) => {
        if (!j) return;
        if (q === 0) say((T.removed || '').replace('[product]', name ? name.textContent.trim() : ''));
        else { const n = $(`.drw [data-key="${CSS.escape(t.dataset.key)}"]`); const ql = n && $('.li__q', n.closest('.li')); if (ql) say(ql.textContent.trim() + ' × ' + (name ? name.textContent.trim() : '')); }
      });
    } else if (t.dataset.lotAdd) {
      const updates = {};
      (t.dataset.lotRemove || '').split(',').forEach((p) => { const i = p.lastIndexOf('='); if (i > 0) updates[p.slice(0, i)] = Math.max(0, +p.slice(i + 1) || 0); });
      api('cart/update.js', { updates }, { path: 'cart/add.js', body: { items: [{ id: +t.dataset.lotAdd, quantity: 1 }] } }).then((j) => { if (j && $('[data-cart-page]')) location.reload(); });
    } else if (t.dataset.step) {
      const o = $(t.dataset.step); if (!o) return;
      o.value = Math.max(+o.min || 1, Math.min(+o.max || 99, (parseInt(o.value, 10) || 1) + +t.dataset.d));
      o.dispatchEvent(new Event('change', { bubbles: true }));
    } else if (t.dataset.zoom) openLightbox(t.closest('[data-product]'), +t.dataset.zoom);
    else if ('lbClose' in t.dataset) t.closest('dialog').close();
    else if (t.dataset.lbStep) stepLightbox(t.closest('dialog'), +t.dataset.lbStep);
    else if ('popClose' in t.dataset) closeDialog(t.closest('dialog'));
    else if ('popOpen' in t.dataset) { const d = $('[data-pop]'); if (d) { t.closest('[data-pop-teaser]').hidden = true; openDialog(d); } }
    else if ('popHide' in t.dataset) { mem.set('solo-pop-t'); t.closest('[data-pop-teaser]').hidden = true; }
    else if (t.dataset.copy) {
      const pick = () => { const c = $('.reward__c', t.closest('.reward') || document); if (c) getSelection().selectAllChildren(c); };
      if (navigator.clipboard) navigator.clipboard.writeText(t.dataset.copy).then(() => toast(T.copied || t.dataset.copy), pick);
      else pick();
    }
    else if (t.closest('.mnav__panel')) { const d = t.closest('details'); d && d.removeAttribute('open'); }
  });
  let cpT;
  document.addEventListener('change', (e) => {
    const el = e.target;
    if (el.matches('.qty input[type=number]')) { const mn = el.min === '' ? 1 : +el.min; el.value = Math.max(mn, Math.min(+el.max || 99, parseInt(el.value, 10) || mn)); }
    if (el.matches('[data-line-qty]')) { clearTimeout(cpT); cpT = setTimeout(() => updateLine(el), 350); }
  });

  /* ---------- page panier : quantités mises à jour sans rechargement ---------- */
  async function updateLine(inp) {
    const form = inp.closest('[data-cart-page]');
    if (!form) return;
    const id = form.dataset.cartPage, key = inp.dataset.lineQty;
    const t0 = $('.li__t', inp.closest('.li')), name = t0 ? t0.textContent.trim() : '';
    form.classList.add('busy');
    try {
      const r = await fetch(root + 'cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: key, quantity: Math.max(0, parseInt(inp.value, 10) || 0), sections: id, sections_url: location.pathname }),
      });
      const j = await r.json().catch(() => ({}));
      if (!r.ok) { toast(j.description || j.message || T.error); return; }
      const wrap = document.getElementById('shopify-section-' + id), html = j.sections && j.sections[id];
      if (wrap && html) {
        // Le focus revient sur la même commande de la même ligne (ou sur la première ligne si elle a disparu).
        const a = document.activeElement, had = wrap.contains(a), li = had && a.closest('[data-line-key]');
        const back = li ? { key: li.dataset.lineKey, d: a.dataset.d } : null;
        const fresh = new DOMParser().parseFromString(html, 'text/html').getElementById('shopify-section-' + id);
        wrap.innerHTML = fresh ? fresh.innerHTML : html;
        if (had) {
          const line = back && $(`[data-line-key="${CSS.escape(back.key)}"]`, wrap);
          const target = (line && (back.d ? $(`[data-d="${back.d}"]`, line) : $('[data-line-qty]', line))) || $('[data-line-qty]', wrap) || $('.btn', wrap);
          target && target.focus({ preventScroll: true });
        }
        const kept = $(`[data-line-key="${CSS.escape(key)}"] [data-line-qty]`, wrap);
        say(kept ? `${kept.value} × ${name}` : (T.removed || '').replace('[product]', name));
      }
      if (typeof j.item_count === 'number') setCount(j.item_count);
      refreshCart();
    } catch (err) { toast(T.error); } finally { form.classList.remove('busy'); }
  }
  document.addEventListener('submit', (e) => {
    const f = e.target.closest('[data-cart-page]');
    if (!f || (e.submitter && e.submitter.name === 'checkout')) return;
    e.preventDefault();
    const inp = document.activeElement && document.activeElement.closest('[data-line-qty]');
    if (inp) { clearTimeout(cpT); updateLine(inp); }
  });

  /* ---------- menus ---------- */
  document.addEventListener('keydown', (e) => {
    if (e.key !== 'Escape') return;
    $$('details.mnav[open],details.dd[open]').forEach((d) => { d.removeAttribute('open'); $('summary', d).focus(); });
  });
  document.addEventListener('click', (e) => {
    $$('details.dd[open],details.mnav[open]').forEach((d) => { if (!d.contains(e.target)) d.removeAttribute('open'); });
  });
  document.addEventListener('focusout', (e) => {
    const d = e.target.closest && e.target.closest('details.dd[open],details.mnav[open]');
    if (d && e.relatedTarget && !d.contains(e.relatedTarget)) d.removeAttribute('open');
  });
  document.addEventListener('toggle', (e) => {
    const d = e.target;
    if (d.matches && d.matches('details.dd') && d.open) $$('details.dd[open]').forEach((o) => o !== d && o.removeAttribute('open'));
  }, true);

  /* ---------- galerie et visionneuse ---------- */
  function initGallery(scope) {
    $$('[data-gal]', scope).forEach((gm) => {
      const counter = $('[data-gal-i]', gm.parentElement);
      if (!counter) return;
      gm.addEventListener('scroll', () => {
        counter.textContent = Math.round(gm.scrollLeft / Math.max(1, gm.clientWidth)) + 1;
      }, { passive: true });
    });
  }
  function openLightbox(sec, i) {
    const d = sec && $('[data-lb]', sec.parentElement.parentElement) || $('[data-lb]');
    if (!d) return;
    d.showModal();
    const tr = $('[data-lb-track]', d);
    tr.scrollTo({ left: tr.clientWidth * i, behavior: 'instant' });
  }
  function stepLightbox(d, s) {
    const tr = $('[data-lb-track]', d);
    tr.scrollTo({ left: tr.scrollLeft + s * tr.clientWidth, behavior: reduce ? 'instant' : 'smooth' });
  }
  document.addEventListener('keydown', (e) => {
    const d = $('dialog.lb[open]');
    if (!d) return;
    if (e.key === 'ArrowRight') stepLightbox(d, 1);
    if (e.key === 'ArrowLeft') stepLightbox(d, -1);
  });

  /* ---------- fiche produit : variantes, formule, bouton, barre fixe ---------- */
  function initProduct(scope) {
    $$('[data-product]', scope).forEach((sec) => {
      const id = sec.dataset.product;
      const form = $(`[data-product-form="${id}"]`);
      if (!form) return;
      const input = $('[data-variant-id]', form);
      const buy = $('[data-buy]', form), label = $('[data-buy-label]', form), bprice = $('[data-buy-price]', form);
      const price = $('[data-price]', sec), stock = $('[data-stock]', sec);
      const sticky = $(`[data-sticky="${id}"]`);
      const sp = sticky && $('[data-sticky-price]', sticky), sb = sticky && $('[data-sticky-buy]', sticky);
      const opts = $('[data-options]', sec);
      const variants = opts ? JSON.parse($('[data-variants]', opts).textContent) : null;
      const formula = $('[data-formula]', sec);
      const single = formula && $('input[data-kind=single]', formula);
      const nt = $('[data-notify]', sec), eta = $('[data-eta]', sec);
      let current = variants ? variants.find((v) => v.id === +input.value) : { id: +input.value, available: !buy.disabled, price: bprice ? bprice.textContent : '' };

      const render = () => {
        const lot = formula && $('input[data-kind=lot]:checked', formula);
        const avail = lot ? true : !!(current && current.available);
        const p = lot ? lot.dataset.price : current && current.price;
        input.value = lot ? lot.value : current ? current.id : input.value;
        buy.disabled = !avail || !current;
        // N'écrit que ce qui change : à l'initialisation, le HTML du serveur est déjà juste (pas de recalcul de mise en page).
        const state = !current ? 'na' : avail ? 'add' : 'out';
        if (label && label.dataset.state !== state) {
          label.dataset.state = state;
          if (state !== 'add') label.textContent = state === 'na' ? T.unavailable : T.sold_out;
          else {
            const lg = document.createElement('span'), sh = document.createElement('span');
            lg.className = 'btn__lg'; lg.textContent = T.add; sh.className = 'btn__sh'; sh.textContent = T.add_short;
            label.replaceChildren(lg, sh);
          }
        }
        if (bprice && p && bprice.innerHTML !== p) bprice.innerHTML = p;
        if (sp && p && sp.innerHTML !== p) sp.innerHTML = p;
        // Épuisé : formulaire « Prévenez-moi » à la place de la date de livraison ; le bouton de la barre fixe y mène.
        const go = state === 'out' && !!nt;
        if (nt) nt.hidden = !go;
        const pb = $('.shopify-payment-button', form);
        if (pb) pb.hidden = state !== 'add';
        if (eta) { eta.dataset.off = state === 'add' ? '' : '1'; if (eta.dataset.off) eta.hidden = true; else if ($('span', eta).textContent) eta.hidden = false; }
        if (sb) {
          sb.disabled = buy.disabled && !go;
          if ((sb.dataset.notifyGo || '') !== (go ? '1' : '')) { sb.dataset.notifyGo = go ? '1' : ''; sb.textContent = go ? T.notify : T.add_short; }
        }
      };
      if (sb && nt) sb.addEventListener('click', (e) => {
        if (!sb.dataset.notifyGo) return;
        e.preventDefault();
        nt.scrollIntoView({ block: 'center', behavior: reduce ? 'instant' : 'smooth' });
        const em = $('input[type=email]', nt);
        if (em) em.focus({ preventScroll: true });
      });

      if (opts) {
        const update = (e) => {
          const sel = [];
          $$('[data-option]', opts).forEach((el) => {
            if ((el.type === 'radio' && el.checked) || el.tagName === 'SELECT') sel[+el.dataset.option] = el.value;
          });
          $$('[data-selected]', opts).forEach((b) => (b.textContent = sel[+b.dataset.selected] || ''));
          current = variants.find((x) => x.options.every((o, i) => o === sel[i])) || null;
          $$('input[data-option]', opts).forEach((r) => {
            const test = sel.slice(); test[+r.dataset.option] = r.value;
            const m = variants.find((x) => x.options.every((o, i) => o === test[i]));
            r.classList.toggle('na', !m || !m.available);
          });
          if (e) say(current ? `${sel.filter(Boolean).join(' / ')} : ${plain(current.price)}${current.available ? '' : ', ' + T.sold_out}` : T.unavailable);
          if (current) {
            if (price) price.innerHTML = `<span>${current.price}</span>` + (current.compare ? `<s><span class="sr">${T.regular} </span>${current.compare}</s>` : '');
            if (stock) stock.innerHTML = current.available && !current.low && stock.dataset.in ? `<i data-cls=""></i>${stock.dataset.in}` : current.stock;
            if (single) { single.value = current.id; single.dataset.price = current.price; const sp2 = $('[data-single-price]', formula); if (sp2) sp2.innerHTML = current.price; }
            if (current.media) {
              const fig = $(`[data-media="${current.media}"]`, sec);
              const gm = fig && fig.parentElement;
              if (gm && gm.scrollWidth > gm.clientWidth) gm.scrollTo({ left: fig.offsetLeft - gm.offsetLeft, behavior: reduce ? 'instant' : 'smooth' });
            }
            if (e) { const u = new URL(location.href); u.searchParams.set('variant', current.id); history.replaceState(history.state, '', u); }
          }
          render();
        };
        opts.addEventListener('change', update);
        update();
      }
      if (formula) formula.addEventListener('change', render);
      render();

      if (sticky) {
        let raf = 0;
        const check = () => {
          raf = 0;
          const r = buy.getBoundingClientRect();
          const visible = r.top < innerHeight && r.bottom > 0;
          const show = !visible && (r.top < 0 || window.scrollY > 160);
          sticky.classList.toggle('show', show);
          sticky.inert = !show;
        };
        window.addEventListener('scroll', () => { if (!raf) raf = requestAnimationFrame(check); }, { passive: true });
        raf = requestAnimationFrame(check);
      }
    });
  }

  /* ---------- date de livraison estimée ---------- */
  // Noms courts intégrés pour les langues du thème : le premier Intl.DateTimeFormat coûte ~15 ms au chargement.
  const DAYS = {
    fr: ['dim.', 'lun.', 'mar.', 'mer.', 'jeu.', 'ven.', 'sam.'], en: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
    es: ['dom', 'lun', 'mar', 'mié', 'jue', 'vie', 'sáb'], it: ['dom', 'lun', 'mar', 'mer', 'gio', 'ven', 'sab'], de: ['So.', 'Mo.', 'Di.', 'Mi.', 'Do.', 'Fr.', 'Sa.'],
  };
  const MONTHS = {
    fr: ['janv.', 'févr.', 'mars', 'avr.', 'mai', 'juin', 'juil.', 'août', 'sept.', 'oct.', 'nov.', 'déc.'], en: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
    es: ['ene', 'feb', 'mar', 'abr', 'may', 'jun', 'jul', 'ago', 'sept', 'oct', 'nov', 'dic'], it: ['gen', 'feb', 'mar', 'apr', 'mag', 'giu', 'lug', 'ago', 'set', 'ott', 'nov', 'dic'],
    de: ['Jan.', 'Feb.', 'März', 'Apr.', 'Mai', 'Juni', 'Juli', 'Aug.', 'Sept.', 'Okt.', 'Nov.', 'Dez.'],
  };
  const ORDER = { fr: (w, d, m) => `${w} ${d} ${m}`, en: (w, d, m) => `${w}, ${m} ${d}`, es: (w, d, m) => `${w}, ${d} ${m}`, it: (w, d, m) => `${w} ${d} ${m}`, de: (w, d, m) => `${w}, ${d}. ${m}` };
  function dateFmt() {
    const k = lang.slice(0, 2).toLowerCase();
    if (ORDER[k]) return (x) => ORDER[k](DAYS[k][x.getDay()], x.getDate(), MONTHS[k][x.getMonth()]);
    const f = new Intl.DateTimeFormat(lang, { weekday: 'short', day: 'numeric', month: 'short' });
    return (x) => f.format(x);
  }
  function initEta(scope) {
    const cfg = T.eta_cfg;
    const els = $$('[data-eta]', scope);
    if (!cfg || !els.length) return;
    const isWork = (d, sat) => { const w = d.getDay(); return w !== 0 && (w !== 6 || sat); };
    const add = (d, n, sat) => { const x = new Date(d); while (n > 0) { x.setDate(x.getDate() + 1); if (isWork(x, sat)) n--; } return x; };
    const now = new Date();
    let ship = new Date(now);
    const today = isWork(now, false) && now.getHours() < cfg.cutoff;
    if (!today) { ship = add(now, 1, false); }
    ship = cfg.prep > 0 ? add(ship, today ? cfg.prep : cfg.prep - 1, false) : ship;
    const min = add(ship, cfg.min, cfg.sat), max = add(ship, cfg.max, cfg.sat);
    const f = dateFmt();
    const tpl = today && cfg.prep === 0 ? T.eta_today : T.eta;
    const html = tpl.replace('[h]', cfg.cutoff).replace('[min]', f(min)).replace('[max]', f(max));
    els.forEach((el) => { $('span', el).innerHTML = html; el.hidden = !!el.dataset.off; });
  }

  /* ---------- repères sur image ---------- */
  function initHotspots(scope) {
    $$('[data-hs]', scope).forEach((hs) => {
      const on = (n, v) => { const m = $(`.hs__m[data-n="${n}"]`, hs); if (m) m.classList.toggle('on', v); };
      $$('.hs__list li', hs).forEach((li) => {
        li.addEventListener('mouseenter', () => on(li.dataset.n, true));
        li.addEventListener('mouseleave', () => on(li.dataset.n, false));
      });
    });
  }

  /* ---------- recommandations ---------- */
  function initRecos(scope) {
    $$('[data-recos]', scope).forEach((el) => {
      const load = () => fetch(el.dataset.recos).then((r) => r.text()).then((html) => {
        const fresh = $('[data-recos-box]', new DOMParser().parseFromString(html, 'text/html'));
        const cards = fresh ? $$('.card', fresh) : [];
        if (!cards.length) return;
        const grid = $('.grid', el);
        if (grid) {
          cards.reverse().forEach((c) => grid.prepend(c));
          grid.style.setProperty('--cols', Math.min(3, grid.children.length));
        } else el.innerHTML = fresh.innerHTML;
        $$('.rv', el).forEach((x) => x.classList.add('in'));
      }).catch(() => {});
      if ('IntersectionObserver' in window) {
        const io = new IntersectionObserver(([en]) => { if (en.isIntersecting) { io.disconnect(); load(); } }, { rootMargin: '600px 0px' });
        io.observe(el.closest('.shopify-section') || el);
      } else load();
    });
  }

  /* ---------- fenêtre newsletter ---------- */
  // Mémoire du navigateur : solo-pop = fenêtre fermée (date), solo-pop-t = onglet de rappel fermé, solo-pop-ok = inscription faite.
  // Pour la visite en cours (sessionStorage) : solo-pop-s = arrivée sur le site, pour que le délai compte le temps passé sur toutes les pages.
  const mem = {
    get: (k) => { try { return +localStorage.getItem(k) || 0; } catch (e) { return 0; } },
    set: (k) => { try { localStorage.setItem(k, Date.now()); } catch (e) {} },
  };
  const visit = () => { try { const s = +sessionStorage.getItem('solo-pop-s'); if (s) return Date.now() - s; sessionStorage.setItem('solo-pop-s', Date.now()); } catch (e) {} return 0; };
  function initPopup(scope) {
    const d = $('[data-pop]', scope);
    if (!d) return;
    const tsr = $('[data-pop-teaser]', scope);
    const span = (+d.dataset.days || 30) * 864e5;
    const recent = (k) => Date.now() - mem.get(k) < span;
    const teaser = () => { if (tsr) tsr.hidden = !!mem.get('solo-pop-ok') || recent('solo-pop-t'); };
    d.addEventListener('close', () => { if (!mem.get('solo-pop-ok')) mem.set('solo-pop'); teaser(); });
    // Après l’envoi d’un formulaire d’inscription, Shopify recharge la page ; l’ancre indique lequel a été envoyé.
    if ($('[data-pop-ok]', d)) mem.set('solo-pop-ok');
    if ('preview' in d.dataset || (location.hash === '#newsletter-popup' && $('[data-pop-ok], [data-pop-err]', d))) { openDialog(d); return; }
    if (mem.get('solo-pop-ok')) return;
    if (recent('solo-pop')) { teaser(); return; }
    const t0 = Date.now();
    // La bannière cookies de Shopify et sa fenêtre de préférences passent d’abord : la fenêtre attend qu’elles soient fermées.
    const cookies = () => ['shopify-pc__banner', 'shopify-pc__prefs__dialog'].some((id) => { const b = document.getElementById(id); return !!b && b.getClientRects().length > 0; });
    const show = () => {
      if (!d.isConnected || d.open || $('dialog[open]')) return;
      clearTimeout(timer);
      if (cookies()) { timer = setTimeout(show, 4000); return; }
      document.removeEventListener('mouseout', out);
      openDialog(d);
    };
    const out = (e) => { if (!e.relatedTarget && e.clientY <= 0 && Date.now() - t0 > 4000 && !cookies()) show(); };
    // Délai compté depuis l’arrivée sur le site ; au moins 4 s sur une nouvelle page, pour ne pas couvrir son affichage.
    let timer = setTimeout(show, Math.max(4000, (+d.dataset.delay || 25) * 1000 - visit()));
    if ('exit' in d.dataset && matchMedia('(pointer: fine)').matches) document.addEventListener('mouseout', out);
  }

  /* ---------- code de bienvenue ---------- */
  // Le lien /discount/CODE enregistre le code pour le paiement ; il suffit de l’appeler une fois.
  function initReward(scope) {
    const r = $('[data-reward][data-apply]', scope);
    if (!r || initReward.on) return;
    initReward.on = true;
    fetch('/discount/' + encodeURIComponent(r.dataset.reward), { credentials: 'same-origin', redirect: 'manual' }).catch(() => {});
  }

  /* ---------- bandeau : messages programmés et temps restant ---------- */
  // Les dates viennent du serveur en secondes ; on les réévalue ici, car la page peut sortir d’un cache.
  function initBar(scope) {
    const bar = $('.bar', scope);
    const els = bar ? $$('.bar__in > [data-start], .bar__in > [data-end]', bar) : [];
    if (!els.length) return;
    const U = T.units || ['j', 'h', 'min'];
    const left = (s) => {
      const d = Math.floor(s / 86400), h = Math.floor((s % 86400) / 3600), m = Math.floor((s % 3600) / 60);
      return d ? `${d}\u00a0${U[0]} ${h}\u00a0${U[1]}` : h ? `${h}\u00a0${U[1]} ${m}\u00a0${U[2]}` : `${Math.max(1, m)}\u00a0${U[2]}`;
    };
    const tick = () => {
      if (!bar.isConnected) return clearInterval(iv);
      const now = Date.now() / 1000;
      els.forEach((el) => {
        const end = +el.dataset.end || 0;
        if (end && now >= end) { el.remove(); return; }
        el.hidden = (+el.dataset.start || 0) > now;
        const cd = $('[data-cd]', el);
        if (cd && end) cd.textContent = (T.ends || '[time]').replace('[time]', left(end - now));
      });
      bar.hidden = !$('.bar__in > span:not([hidden])', bar);
    };
    const iv = setInterval(tick, 30000);
    tick();
    document.addEventListener('visibilitychange', () => { if (!document.hidden) tick(); });
  }

  /* ---------- apparitions ---------- */
  // Le contenu reste visible sans JS : on ne masque (classe anim-ready) qu’après avoir affiché ce qui est déjà à l’écran.
  function initReveal(scope) {
    const html = document.documentElement;
    if (!html.classList.contains('anim') || reduce || !('IntersectionObserver' in window)) return;
    const els = $$('.rv:not(.in)', scope);
    const vh = innerHeight;
    const rest = els.filter((e) => { const r = e.getBoundingClientRect(); if (r.top < vh && r.bottom > 0) { e.classList.add('in'); return false; } return true; });
    html.classList.add('anim-ready');
    const io = new IntersectionObserver((es) => es.forEach((en) => { if (en.isIntersecting) { en.target.classList.add('in'); io.unobserve(en.target); } }), { rootMargin: '0px 0px -6% 0px' });
    rest.forEach((e) => io.observe(e));
  }

  const init = (scope = document) => { initGallery(scope); initProduct(scope); initEta(scope); initHotspots(scope); initRecos(scope); initReveal(scope); initPopup(scope); initReward(scope); initBar(scope); };
  init();
  document.addEventListener('shopify:section:load', (e) => { init(e.target); $$('.rv', e.target).forEach((x) => x.classList.add('in')); });
})();
